import { render, staticRenderFns } from "./TrackingChart.vue?vue&type=template&id=2224ed4c&scoped=true"
import script from "./TrackingChart.vue?vue&type=script&lang=js"
export * from "./TrackingChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2224ed4c",
  null
  
)

export default component.exports